import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useThemeMode } from '../contexts/ThemeContext';

const ThemeModeToggle: React.FC = () => {
  const { mode, toggleTheme } = useThemeMode();

  return (
    <Tooltip title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          color: mode === 'light' ? '#333' : '#f0f4f8',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            backgroundColor: 'rgba(0, 212, 255, 0.1)',
            transform: 'rotate(180deg)',
          },
        }}
        aria-label={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      >
        {mode === 'light' ? (
          <DarkMode sx={{ fontSize: 24 }} />
        ) : (
          <LightMode sx={{ fontSize: 24, color: '#ffaa00' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeModeToggle;